import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.413 2c.368 0 .667.298.667.667a.52.52 0 0 0 .518.518.667.667 0 1 1 0 1.334.52.52 0 0 0-.518.518.667.667 0 0 1-1.334 0 .52.52 0 0 0-.518-.518.667.667 0 0 1 0-1.334.52.52 0 0 0 .518-.518c0-.369.299-.667.667-.667"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.218 2.195a.667.667 0 0 0-.943 0l-8.889 8.89a.667.667 0 0 0 0 .942l1.778 1.778c.26.26.682.26.943 0l8.889-8.89a.667.667 0 0 0 0-.942zm-.472 3.084.835-.835-.835-.835-.835.835zm-1.777.108L3.8 11.556l.835.835 6.169-6.169z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.006 8.593a.667.667 0 0 0-1.334 0 .52.52 0 0 1-.518.518.667.667 0 0 0 0 1.333.52.52 0 0 1 .518.519.667.667 0 0 0 1.334 0 .52.52 0 0 1 .518-.519.667.667 0 0 0 0-1.333.52.52 0 0 1-.518-.518"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })